<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="KCPS VNコネクト削除"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col>
                <span
                  >削除が必要なVNコネクトが存在します。削除を行ってください。</span
                ><br />
                <span>削除が完了するまでVNコネクトの操作はできません。</span>
              </v-col>
            </v-row>
            <app-table
              primary-key="cloudVnConnectAct.wnumber"
              :fields="vnConnects.fields"
              :items="pendingDeleteItem ? [pendingDeleteItem] : []"
              :per-page="-1"
              :tr-class="() => undefined"
            >
              <template #cell(wnumber)="{ item }">
                {{ item.cloudVnConnectAct.wnumber }}<br />
                <template v-if="item.cloudVnConnectSby">{{
                  item.cloudVnConnectSby.wnumber
                }}</template>
                <template v-else>-</template>
              </template>
              <template #cell(vnConnectName)="{ item }">
                {{ item.cloudVnConnectAct.vnConnectName }}<br />
                <template v-if="item.cloudVnConnectSby">{{
                  item.cloudVnConnectSby.vnConnectName
                }}</template>
                <template v-else>-</template>
              </template>
              <template #cell(serviceKey)="{ item }">
                {{ item.cloudVnConnectCommon.serviceKey }}
              </template>
              <template #cell(vpnVnCode)="{ item }">
                <template
                  v-if="item.cloudVnConnectCommon.vpnVnCode.charAt(0) !== 'B'"
                >
                  {{
                    `${item.cloudVnConnectCommon.vpnVnCode}(${item.cloudVnConnectCommon.vnType})`
                  }}
                </template>
                <template v-else>
                  {{ item.cloudVnConnectCommon.vpnVnCode }}
                </template>
              </template>
              <template #cell(bandwidth)="{ item }">
                {{ item.cloudVnConnectCommon.bandwidthType }}({{
                  $filter.bandwidthTo(item.cloudVnConnectCommon.bandwidth)
                }})
              </template>
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="
                showVNConnectDelete(
                  pendingDeleteItem!.cloudVnConnectAct.wnumber
                )
              "
              variant="flat"
              color="primary"
              >削除</v-btn
            >
            <v-btn @click="cancel" variant="outlined" color="primary"
              >キャンセル</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { CloudVnKcpsList } from "@/apis/CloudVnKcpsApi";
import type { AppTableHeader } from "@/components/AppTable.vue";
import V2MultiCloudKcps3VnConnectionDeleteConfirm from "@/modals/multicloud/kcps3/v2/V2MultiCloudKcps3VnConnectionDeleteConfirm.vue";

export default defineComponent({
  name: "MultiCloudKcps3VnConnectionPendingDelete",
  props: {
    /** クラウド回線SEQ */
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
    vnConnectList: {
      type: Object as PropType<CloudVnKcpsList>,
      required: true,
    },
    cloudVnKcpsKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      vnConnects: {
        fields: [
          {
            key: "wnumber",
            title: "VNコネクト番号(Act/Sby)",
            width: "150px",
          },
          {
            key: "vnConnectName",
            title: "VNコネクト名(Act/Sby)",
            width: "140px",
          },
          {
            key: "serviceKey",
            title: "KCPSユーザーID",
            width: "160px",
          },
          {
            key: "vpnVnCode",
            title: "接続先VPN/VNコード",
            width: "185px",
          },
          {
            key: "bandwidth",
            title: "品目",
            width: "140px",
          },
        ] as AppTableHeader<CloudVnKcpsList>[],
      },
      isLoaded: false,
    };
  },
  computed: {
    /** 削除対象のVNコネクト（仕様上1件のみ・V2のみ対象） */
    pendingDeleteItem(): CloudVnKcpsList["cloudVnConnectsList"][0] | undefined {
      return this.vnConnectList.cloudVnConnectsList.find(
        (item) =>
          item.cloudVnConnectCommon.version === "V2" &&
          item.cloudVnConnectCommon.provStatus === "PENDING_DELETE"
      );
    },
  },
  async mounted() {
    this.isLoaded = true;
  },
  methods: {
    /** VNコネクト削除 */
    async showVNConnectDelete(wnumber: string) {
      const cloudDetail = await this.$api.cloudVnKcps.getVnConnectV2(wnumber);
      await this.$modal.show(V2MultiCloudKcps3VnConnectionDeleteConfirm, {
        cloudVnKcpsDetail: cloudDetail,
        billingFreeFlg: cloudDetail.cloudVnConnectCommon.billingFree,
      });
      await this.$api.cloudVnKcps.deleteVnConnectV2(this.cloudLineSeq, {
        cloudVnConnectList: [
          cloudDetail.cloudVnConnectAct.wnumber,
          cloudDetail.cloudVnConnectSby.wnumber,
        ],
        cloudVnKcpsKeyId: this.cloudVnKcpsKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
